import { BookingStatus } from "generated/graphql";

export const ForbiddenBookingTrackingStatuses = new Set([
  BookingStatus.Quotation,
  BookingStatus.Waiting,
  BookingStatus.Allocated,
  BookingStatus.Declined,
  BookingStatus.EBooking,
  BookingStatus.Invoice,
  BookingStatus.ScheduledTemplate,
  BookingStatus.ProofOfDelivery,
  BookingStatus.Complete,
]);

export const isDriverTrackingAllowed = (status: BookingStatus | undefined) => {
  return status ? !ForbiddenBookingTrackingStatuses.has(status) : false;
};
